"use strict";
import AOS from "aos";
import main from "../css/sass/main.scss";
import inline from "../css/sass/inline.scss";
import "@splidejs/splide/css";
import mobileMenu from "./scripts/menu/mobileMenu";
import headerScrolling from "./scripts/headerScrolling";
import heroSlider from "./scripts/heroSlider";
import genteSlider from "./scripts/genteSlider";
import clienteSlider from "./scripts/clienteSlider";
import programasSlider from "./scripts/programasSlider";
import accordion from "./scripts/accordion";
import obrasFilter from "./scripts/obrasFilter";

AOS.init({
    once: true,
});

mobileMenu();
headerScrolling();
heroSlider();
genteSlider();
clienteSlider();
programasSlider();
accordion();
obrasFilter();
